import responsive from './assets/features/desktop/responsive.svg';
import noLimit from './assets/features/desktop/no-limit.svg';
import embed from './assets/features/desktop/embed.svg';
import customDomain from './assets/features/desktop/custom-domain.svg'
import boost from './assets/features/desktop/boost-exposure.svg'
import dragDrop from './assets/features/desktop/drag-drop.svg'


export const Featur = [
  {
    image: responsive,
    title: "100% responsive",
    text: "No matter which the device you're on, our site is fully responsive and stories look beautiful on any screen",
  },
  {
    image: noLimit,
    title: "no photo upload limit",
    text: "Our tool has no limits on uploads or bandwidth. Freely upload in bulk and share all of your stories in one go.",
  },
  {
    image: embed,
    title: "available to embed",
    text: "Embed Tweets, Facebook posts, Instagram media, Vimeo or Youtube videos, Google Maps, and more.",
  },
];


export const Feature = [
  {
    image: responsive,
    title: "100% responsive",
    text: "No matter which the device you're on, our site is fully responsive and stories look beautiful on any screen",
  },
  {
    image: noLimit,
    title: "no photo upload limit",
    text: "Our tool has no limits on uploads or bandwidth. Freely upload in bulk and share all of your stories in one go.",
  },
  {
    image: embed,
    title: "available to embed",
    text: "Embed Tweets, Facebook posts, Instagram media, Vimeo or Youtube videos, Google Maps, and more.",
  },
  
  {
    image: customDomain,
    title: "custom domain",
    text: "With Photosnap subscriptions you can host your stories on your own domain. You can can also remove our branding.",
  },
  {
    image: boost,
    title: "boost your exposure",
    text: "users that viewed your story or gallery can easily get notified of new and featured stories with our built in mailing list.",
  },
  {
    image: dragDrop,
    title: "drag & drop image",
    text: "Easily drag and drop your image and get beautiful shots everytime. No over the top tolling to add friction to creating stories.",
  },
]
